import api from 'common/api';
import {
  SearchDisplayItemMasterRequest,
  DetailDisplayItemMasterRequest,
  UpdateDisplayItemMasterRequest,
  DeleteDisplayItemMasterRequest,
  CopyDisplayItemMasterRequest,
  DetailForCargoDisplayItemMasterRequest,
  UserListDisplayItemMasterRequest,
} from 'api-types/src/types/display-item-master';

export const getListSearchMenuItem = (params: SearchDisplayItemMasterRequest) =>
  api.get('/display-item-name/list', params);

export const getDetailMenuItemAPI = (params: DetailDisplayItemMasterRequest) =>
  api.get('/display-item-name/detail-screen', params);

export const getDetailItemAPI = (params: DetailForCargoDisplayItemMasterRequest) =>
  api.get('/display-item-name/detail', params);

export const registerMenuDisplayAPI = (params: UpdateDisplayItemMasterRequest) =>
  api.post('/display-item-name', params);

export const updateDetailMenuItemAPI = (params: UpdateDisplayItemMasterRequest) =>
  api.put('/display-item-name', params);

export const deleteDetailMenuItemAPI = (params: DeleteDisplayItemMasterRequest) =>
  api.put('/display-item-name/delete-master-maintenance', params);

export const getListScreenAPI = () => api.get('/display-item-name/screen-list');

export const getUserIdListDataAPI = (params: UserListDisplayItemMasterRequest) =>
  api.get('/display-item-name/user-list-for-copy', params);

export const copyItemDisplayAPI = (params: CopyDisplayItemMasterRequest) => api.post('/display-item-name/copy', params);

export const exportExcelItemDisplayAPI = (params: SearchDisplayItemMasterRequest) =>
  api.get('/display-item-name/export-excel', params);
